import { FieldConfig } from '../../models/form-field.model';


export class FormDateField<N> extends FieldConfig<N> {
  containerStyles?: any;
  dateStyles?: any;
  fieldType?: 'date' | 'datetime';
  date?: {
    min?: Date,
    max?: Date
  }

  constructor(o: FormDateField<N>) {
    super(o);
    this.type = 'date';
    if (!o.fieldType) {
      this.fieldType = 'date';
    }
  }
}
